import React from 'react'
import {useTranslation} from "react-i18next";
import {Link} from 'react-router-dom'

import Aux from "../../hoc/Auxiliary";
import DateFormated from '../Utils/Date/Date';
import Spinner from "../UI/Spinner";
import Currency from "../Utils/Number/Currency";

const cardBoard = (props) => {
    const { t } = useTranslation();

    let boardHtml;
    if(props.loading || props.loadingAccount){
        boardHtml = (
            <div className='cardboard__content col-md-12'>
                <Spinner />
            </div>
        );
    }
    if(props.data !== null && props.account && !props.loading && !props.loadingAccount){
        const type = props.data.accountType.code;
        boardHtml = (
            <Aux>
                <div className='cardboard__content col-md-8 col-lg-11'>
                    <div className='cardboard__content__duedate'>
                        {(() => {
                            if((type === 'K' || type === 'H')){
                                if(props.data.oldestDueDate){
                                    return (
                                        <>
                                            <div>{t("card.echeance")}</div>
                                            <strong>
                                                <DateFormated date={props.data.oldestDueDate} />
                                            </strong>
                                        </>
                                    )
                                }
                            } else {
                                return(<strong>{t("card.amounttotal")}</strong>);
                            }
                        })()}
                    </div>
                    <div className='cardboard__content__amount'>
                        <strong className='price mb-2'><Currency value={props.account.totalBalance.value} /></strong>
                        {/*
                            props.user !== null && props.user.paymentAllowed && props.account.totalBalance.value > 0
                            && props.btnPayAll &&
                            <Link className='btn btn--outline btn--outline--black btn--payment mb-2'
                                to={{pathname:'/payment',
                                    state: {by: "fix", selection : null}
                                }} >
                                <i className="fas fa-file-invoice-dollar"></i>&nbsp;&nbsp;{t('payment.button')}
                            </Link>
                        */}
                    </div>
                </div>

            </Aux>
        );
    }
    if(props.data === null && !props.loading && !props.loadingAccount){
        boardHtml = <div className='cardboard__content col-md-12'>
            <p><strong>{t("cardboard.empty")}</strong></p>
        </div>
    }

    return(
        <div className='cardboard'>
            <div className='cardboard__header'>
                <h2 className='cardboard__header__title'>{props.title}</h2>
            </div>
            <div className='cardboard__wrapper'>
                {boardHtml}
                <div className='cardboard__actions'>
                    <Link className='link link--accent link--upper link--fs-14' to={props.link}>
                        <strong>{t("cardboard.consultlink")}&nbsp;&nbsp;<i className='fa fa-angle-right'></i></strong>
                    </Link>
                    <br/>
                    <Link className='link link--accent link--upper link--fs-14' to={props.link_accountstatement}>
                        <strong>{t("cardboard.consultlinkstatement")}&nbsp;&nbsp;<i className='fa fa-angle-right'></i></strong>
                    </Link>
                    <br/>
                    <Link className='link link--accent link--upper link--fs-14' to={props.link_priceletter}>
                        <strong>{t("cardboard.consultlinkpriceletter")}&nbsp;&nbsp;<i className='fa fa-angle-right'></i></strong>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default cardBoard
